module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Klimaatverandering in Nederland","short_name":"Klimaatverandering in Nederland","start_url":"/","background_color":"#333333","theme_color":"#49b0f2","display":"standalone","icon":"src/images/favicon.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"c61af1beeb9585b619c589d0db9f2939"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
